export default "__VITE_ASSET__a3seLth4__"